


































import { Component, Vue } from 'vue-property-decorator';
import { RouteRecord } from 'vue-router';
import { getSchoolInfo } from '@/utils/utils';
import config from '@/school.config';

@Component({
  components: {
  },
})
export default class StudentHomeDetail extends Vue {
  public config = config;
  public isEdit = false;

  public get routes(): Array<any> {
    const router = this.$route as any;
    return router.matched.filter((item: RouteRecord) => item.meta && item.meta.routerName);
    
  }
public created(){



}
  public get school() {
    return getSchoolInfo().shortName;
  }

  public changeIsEdit(isEdit: boolean): void {
    this.isEdit = isEdit;
  }
}
